export function toggleFormDefaultAnimation(hidden) {
    const email = document.getElementById('form-email'),
        phone = document.getElementById('form-phone');

    if (hidden) {
        if (window.innerWidth >= 905) {
            email.closest('label').classList.remove('selectmenu-open');
            phone.closest('label').classList.remove('selectmenu-open');
        }
    } else {
        if (window.innerWidth >= 905) {
            email.closest('label').classList.toggle('selectmenu-open');
            phone.closest('label').classList.toggle('selectmenu-open');
        }
    }
}
